import type { youchuanModelConfig } from './types';
import { buildFinalPrompt } from './prompt';

export const youchuanModelConfigs: Record<string, youchuanModelConfig> = {
    'youchuan-t2i-v8.2': {
        // https://tob.youchuan.cn/docs/export/list#%E6%96%87%E7%94%9F%E5%9B%BE-diffusion
        apiPath: '/v1/tob/diffusion',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution } = params;
            return {
                text: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    image_resolution,
                    // system
                    mjVersion: '8.2',
                    supportsImageResolution: true,
                }),
            };
        },
    },
    'youchuan-i2i-v8.2': {
        // https://tob.youchuan.cn/docs/export/list#%E8%BD%AC%E7%BB%98-retexture
        apiPath: '/v1/tob/retexture',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            return {
                remixPrompt: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    image_resolution,
                    // system
                    mjVersion: '8.2',
                    supportsImageResolution: true,
                }),
                // 图片 URL
                imgUrl: image_urls[0],
            };
        },
    },
    'youchuan-t2i-v8.1': {
        // https://tob.youchuan.cn/docs/export/list#%E6%96%87%E7%94%9F%E5%9B%BE-diffusion
        apiPath: '/v1/tob/diffusion',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution } = params;
            return {
                text: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    image_resolution,
                    // system
                    mjVersion: '8.1',
                    supportsImageResolution: true,
                }),
            };
        },
    },
    'youchuan-i2i-v8.1': {
        // https://tob.youchuan.cn/docs/export/list#%E8%BD%AC%E7%BB%98-retexture
        apiPath: '/v1/tob/retexture',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            return {
                remixPrompt: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    image_resolution,
                    // system
                    mjVersion: '8.1',
                    supportsImageResolution: true,
                }),
                // 图片 URL
                imgUrl: image_urls[0],
            };
        },
    },
    'youchuan-t2i-niji7': {
        // https://tob.youchuan.cn/docs/export/list#%E6%96%87%E7%94%9F%E5%9B%BE-diffusion
        apiPath: '/v1/tob/diffusion',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                text: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    // system
                    mjVersion: '7',
                    useNiji: true,
                }),
            };
        },
    },
    'youchuan-i2i-niji7': {
        // https://tob.youchuan.cn/docs/export/list#%E8%BD%AC%E7%BB%98-retexture
        apiPath: '/v1/tob/retexture',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio } = params;
            return {
                remixPrompt: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    // system
                    mjVersion: '7',
                    useNiji: true,
                }),
                // 图片 URL
                imgUrl: image_urls[0],
            };
        },
    },
    'youchuan-t2i-v7': {
        // https://tob.youchuan.cn/docs/export/list#%E6%96%87%E7%94%9F%E5%9B%BE-diffusion
        apiPath: '/v1/tob/diffusion',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                text: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    // system
                    mjVersion: '7',
                }),
            };
        },
    },
    'youchuan-i2i-v7': {
        // https://tob.youchuan.cn/docs/export/list#%E8%BD%AC%E7%BB%98-retexture
        apiPath: '/v1/tob/retexture',
        pollApiPath: '/v1/tob/job',
        statusMapping: {
            taskIdPath: 'id',
            success: [2],
            failed: [3],
            processing: [0, 1],
            statePath: 'status',
            imageUrlPath: 'urls',
            errorPath: 'comment',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio } = params;
            return {
                remixPrompt: buildFinalPrompt({
                    prompt: prompt,
                    aspectRatio: aspectRatio,
                    // system
                    mjVersion: '7',
                }),
                // 图片 URL
                imgUrl: image_urls[0],
            };
        },
    },
};